/**
 * Phase 6e.4.2-hotfix-2 — extracted from ContractListPage so the
 * shared DeleteConfirmDialog (now also used by ContractEntryPage) can
 * render the same slot label.
 */

import type { ContractInput } from "@/types";

export function displayNameFor(
  contract: ContractInput | null,
  emptyLabel: string,
): string {
  if (!contract) return emptyLabel;
  return (
    contract.description?.trim() ||
    contract.contractId?.trim() ||
    emptyLabel
  );
}
